import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormikDropdown from "../../components/inputFields/FormikDropDown";

const itemOptions = [
  { value: "item1", label: "Item 1" },
  { value: "item2", label: "Item 2" },
  { value: "item3", label: "Item 3" },
];

const RequestReplacementSchema = Yup.object().shape({
  itemName: Yup.string().required("Required"),
  itemId: Yup.string().required("Required"),
  quantity: Yup.number().min(1, "Must be at least 1").required("Required"),
  reason: Yup.string().required("Required"),
  requestedBy: Yup.string(),
});

const RequestReplacementForm = () => {
  return (
    <>
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Request Replacement</h1>
        <p className="text-gray-600">Submit a replacement request for inventory items</p>
      </div>

      {/* Form Card */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <Formik
          initialValues={{
            itemName: "",
            itemId: "",
            quantity: 1,
            reason: "",
            requestedBy: "",
          }}
          validationSchema={RequestReplacementSchema}
          onSubmit={(values) => {
            console.log("Request Replacement Submitted:", values);
          }}
        >
          {({ errors, touched }) => (
            <Form className="space-y-6">
              {/* Item Details Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormikDropdown
                  label="Item Name"
                  name="itemName"
                  options={itemOptions}
                  required
                  height={36}
                />
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Item ID/Code<span className="text-red-500 ml-1">*</span>
                  </label>
                  <Field
                    name="itemId"
                    className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Enter Item ID or Code"
                  />
                  {touched.itemId && errors.itemId && (
                    <div className="text-red-500 text-xs mt-1">{errors.itemId}</div>
                  )}
                </div>
              </div>

              {/* Quantity and Requester Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Quantity<span className="text-red-500 ml-1">*</span>
                  </label>
                  <Field
                    name="quantity"
                    type="number"
                    min={1}
                    className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Enter quantity"
                  />
                  {touched.quantity && errors.quantity && (
                    <div className="text-red-500 text-xs mt-1">{errors.quantity}</div>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Requested By
                  </label>
                  <Field
                    name="requestedBy"
                    className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Your Name (optional)"
                  />
                </div>
              </div>

              {/* Reason */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Reason for Replacement<span className="text-red-500 ml-1">*</span>
                </label>
                <Field
                  as="textarea"
                  name="reason"
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Explain why replacement is needed..."
                />
                {touched.reason && errors.reason && (
                  <div className="text-red-500 text-xs mt-1">{errors.reason}</div>
                )}
              </div>

              {/* Submit Button */}
              <div className="flex justify-end pt-4 border-t border-gray-200">
                <button
                  type="submit"
                  className="bg-primary hover:bg-primary/80 text-white px-6 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  Submit Request
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default RequestReplacementForm; 